import parsePhoneNumber from "libphonenumber-js"

export const isPhoneValid = (phone: string, strict?: boolean) => {
  try {
    const phoneNumber = parsePhoneNumber(phone)
    return strict ? phoneNumber?.isValid() : phoneNumber.isPossible()
  } catch {
    return false
  }
}
